import { render } from "./MisPagos.vue?vue&type=template&id=36c049d8"
import script from "./MisPagos.vue?vue&type=script&lang=js"
export * from "./MisPagos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__